import PlusAnimation from "../../../assets/animations/SP-BusinessPlus-Animation-v1.0.mp4";

const data = {
  animation: PlusAnimation,
  intro: {
    title: "Interactive Demos",
    heading: "See SailPoint Identity Security Cloud in action",
    instruction: "Select a topic",
  },
  demos: [],
};

export default data;
